export const getRandomSpawnPos = (maxX: number, bounds = 32): number[] => {
  const x = Math.floor(Math.random() * (maxX - bounds * 1.5 - 1) + bounds);
  const y = -Math.floor(Math.random() * (700 - bounds + 1) + bounds);

  return [x, y];
};

export const getRandomStep = (totalItems: number, maxWidth: number, minStep: number): number =>
  Math.floor(Math.random() * (maxWidth / totalItems) - minStep) + minStep;
